module.exports = __webpack_public_path__ + "img/rca-logo-black.89f80075.svg";